import React from 'react';
import PropTypes from 'prop-types';

const SvgCamera = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#ffffff';
    const strokeColor = active ? '#ffffff' : '#343A72';
    const color = active ? '#7AB3B3' : '#EAEBF0';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="20" fill="none" viewBox="0 0 26 20" {...props}>
            <path
                fill={fillColor}
                fillRule="evenodd"
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M23.743 18.428H1.784A.78.78 0 0 1 1 17.653V3.711a.78.78 0 0 1 .784-.774h4.773a.79.79 0 0 0 .555-.227l1.5-1.483A.79.79 0 0 1 9.169 1h7.192a.79.79 0 0 1 .555.227l1.5 1.483a.79.79 0 0 0 .556.227h4.772a.78.78 0 0 1 .785.774v13.942a.78.78 0 0 1-.785.775Z"
                clipRule="evenodd"
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="M24.528 8.47H1V3.71a.78.78 0 0 1 .784-.773h4.773a.79.79 0 0 0 .555-.227l1.5-1.483A.79.79 0 0 1 9.169 1h7.192a.79.79 0 0 1 .555.227l1.5 1.483a.79.79 0 0 0 .556.227h4.772a.78.78 0 0 1 .785.774v4.758Z"
                clipRule="evenodd"
            />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M24.528 8.47H1V3.71a.78.78 0 0 1 .784-.773h4.773a.79.79 0 0 0 .555-.227l1.5-1.483A.79.79 0 0 1 9.169 1h7.192a.79.79 0 0 1 .555.227l1.5 1.483a.79.79 0 0 0 .556.227h4.772a.78.78 0 0 1 .785.774v4.758Z"
                clipRule="evenodd"
            />
            <path
                fill={fillColor}
                fillRule="evenodd"
                d="M7.386 10.682c0-2.933 2.408-5.311 5.378-5.311s5.378 2.378 5.378 5.311c0 2.934-2.408 5.311-5.378 5.311s-5.378-2.377-5.378-5.311"
                clipRule="evenodd"
            />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M7.386 10.682c0-2.933 2.408-5.311 5.378-5.311s5.378 2.378 5.378 5.311c0 2.934-2.408 5.311-5.378 5.311s-5.378-2.377-5.378-5.311Z"
                clipRule="evenodd"
            />
            <path
                fill={strokeColor}
                fillRule="evenodd"
                d="M20.718 5.703c0-.548.454-.996 1.009-.996.556 0 1.008.448 1.008.996 0 .55-.452.995-1.008.995a1.004 1.004 0 0 1-1.009-.995Z"
                clipRule="evenodd"
            />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M17.652 8.47h6.876"
            />
        </svg>
    );
};
SvgCamera.propTypes = {
    active: PropTypes.bool,
};
SvgCamera.defaultProps = {
    active: false,
};

export default SvgCamera;
